import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Trigger = styled.button<{ $hasError?: boolean }>`
  width: 100%;
  padding: 0.75rem;
  background-color: ${({ theme }) => theme.colors.neutral};
  border: 1px solid
    ${({ theme, $hasError }) =>
      $hasError ? theme.colors.red800 : theme.colors.neutral100};
  border-radius: 4px;
  font-size: 18px;
  transition: border-color 0.2s;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.neutral700};

  &:focus {
    outline: none;
    border-color: ${({ theme, $hasError }) =>
      $hasError ? theme.colors.red800 : theme.colors.primary600};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const TriggerText = styled.span<{ $placeholder?: boolean }>`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme, $placeholder }) =>
    $placeholder ? theme.colors.neutral500 : theme.colors.neutral700};
`;

export const Panel = styled.ul`
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  margin: 0;
  padding: 0.25rem 0;
  max-height: 240px;
  overflow-y: auto;
  list-style: none;
  background-color: ${({ theme }) => theme.colors.neutral};
  border: 1px solid ${({ theme }) => theme.colors.neutral100};
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  z-index: 20;
`;

export const OptionRow = styled.li`
  margin: 0;
`;

export const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.neutral700};

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutral100};
  }
`;
